"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _sbUtils = require("@simplybenefits/sb-utils");
var _system = require("@mui/system");
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _theme = require("../../../../theme");
var _DividerLine = require("../../../../components/DividerLine");
var _HeaderBar = require("../../../../components/HeaderBar");
var _Text = _interopRequireDefault(require("../../../../components/Text"));
var _Button = _interopRequireDefault(require("../../../../components/Button"));
var _i18n = _interopRequireDefault(require("../../../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../../../localization/tokens"));
var Block = (0, _system.styled)('div')({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  paddingRight: 10
});
var Row = (0, _system.styled)('div')({
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
  padding: "5px 30px 0 50px"
});
var styles = {
  summaryHeader: {
    paddingTop: "0px",
    paddingRight: "8px",
    paddingBottom: "0px",
    paddingLeft: "0px"
  }
};

/**
 * @param divisionTitle
 * @param invoice
 * @param isCurrent
 * @param account
 * @param loading
 * @param isMasterSite
 * @param isDivisionSummary
 * @param selectedDivisionID
 * @param triggerDivisionRepayment
 * @param overallSummary
 * @param blockMemberDetails
 * @param downloadInvoiceCSV
 * @param downloadInvoice
 * @param downloadPayrollDeductions
 * @returns {JSX.Element}
 * @constructor
 */
var Summary = function Summary(_ref) {
  var _invoice$meta;
  var divisionTitle = _ref.divisionTitle,
    invoice = _ref.invoice,
    isCurrent = _ref.isCurrent,
    account = _ref.account,
    loading = _ref.loading,
    isMasterSite = _ref.isMasterSite,
    isDivisionSummary = _ref.isDivisionSummary,
    selectedDivisionID = _ref.selectedDivisionID,
    triggerDivisionRepayment = _ref.triggerDivisionRepayment,
    overallSummary = _ref.overallSummary,
    blockMemberDetails = _ref.blockMemberDetails,
    downloadInvoiceCSV = _ref.downloadInvoiceCSV,
    downloadInvoice = _ref.downloadInvoice,
    downloadPayrollDeductions = _ref.downloadPayrollDeductions;
  var carryForward = overallSummary.totals.carryForward || 0;
  return /*#__PURE__*/_react["default"].createElement(Block, null, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 12,
    md: 8,
    sx: styles.summaryHeader
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    largest: true,
    bold: true
  }, divisionTitle ? "".concat(divisionTitle, " ") : '', _i18n["default"].t(_tokens["default"].titles.summary)), invoice !== null && invoice !== void 0 && (_invoice$meta = invoice.meta) !== null && _invoice$meta !== void 0 && _invoice$meta.invoiceNum ? /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "flex",
      flexDirection: "row",
      marginTop: 5
    }
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    light: true,
    customStyle: {
      marginRight: 5
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.invoiceNumber), ":"), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true
  }, invoice.meta.invoiceNum)) : null), !isCurrent && !loading ? /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    justifyContent: "flex-end"
  }, isMasterSite && isDivisionSummary && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: triggerDivisionRepayment,
    transparent: true
  }, _i18n["default"].t(_tokens["default"].labels.invoices.triggerRepayment))), !blockMemberDetails && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: downloadInvoiceCSV,
    transparent: true
  }, _i18n["default"].t(_tokens["default"].buttons.downloadCsv))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    transparent: true,
    onClick: function onClick() {
      return downloadInvoice(isDivisionSummary, selectedDivisionID);
    }
  }, _i18n["default"].t(_tokens["default"].buttons.downloadPdf))), !isDivisionSummary && invoice.payrollDeductions.length > 0 && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    transparent: true,
    onClick: function onClick() {
      return downloadPayrollDeductions();
    }
  }, _i18n["default"].t(_tokens["default"].buttons.downloadPayrollDeductions)))))) : !isDivisionSummary && invoice.payrollDeductions.length > 0 && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    justifyContent: "flex-end"
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    transparent: true,
    onClick: function onClick() {
      return downloadPayrollDeductions();
    }
  }, _i18n["default"].t(_tokens["default"].buttons.downloadPayrollDeductions)))))), !isDivisionSummary && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_HeaderBar.HeaderBar, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    mediumLarge: true,
    bold: true,
    color: _theme.colors.surface
  }, _i18n["default"].t(_tokens["default"].labels.invoices.previousMonthPremiumDue))), /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.premiumDueLastMonth)), /*#__PURE__*/_react["default"].createElement(_Text["default"], null, _sbUtils.helpers.formatNumber(invoice.lastInvoice.total, 2, true))), /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.paymentReceived)), /*#__PURE__*/_react["default"].createElement(_Text["default"], null, _sbUtils.helpers.formatNumber(invoice.lastInvoice.payment, 2, true))), /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.carryForwardBalance)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    bold: true
  }, _sbUtils.helpers.formatNumber(carryForward, 2, true)))), /*#__PURE__*/_react["default"].createElement(_HeaderBar.HeaderBar, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    mediumLarge: true,
    bold: true,
    color: _theme.colors.surface
  }, _i18n["default"].t(_tokens["default"].labels.invoices.currentMonthPremiumDue))), /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.adjustmentsForPriorPeriod)), /*#__PURE__*/_react["default"].createElement(_Text["default"], null, _sbUtils.helpers.formatNumber(overallSummary.totals.adjustments instanceof Object ? overallSummary.totals.adjustments.net : overallSummary.totals.adjustments, 2, true))), Boolean(account.isAsoHealth === 1 || account.isAsoDental) && /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.asoBalanceAdjustment)), /*#__PURE__*/_react["default"].createElement(_Text["default"], null, _sbUtils.helpers.formatNumber(overallSummary.totals.asoAdjustments || 0, 2, true))), /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.miscPremiums)), /*#__PURE__*/_react["default"].createElement(_Text["default"], null, _sbUtils.helpers.formatNumber(overallSummary.miscPremiums.premium, 2, true))), /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.optionalBenefits)), /*#__PURE__*/_react["default"].createElement(_Text["default"], null, _sbUtils.helpers.formatNumber(overallSummary.optionalBenefits.premium, 2, true))), /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.totalPremiumForPeriod)), /*#__PURE__*/_react["default"].createElement(_Text["default"], null, _sbUtils.helpers.formatNumber(overallSummary.totals.premium, 2, true))), /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.carryForward)), /*#__PURE__*/_react["default"].createElement(_Text["default"], null, _sbUtils.helpers.formatNumber(carryForward, 2, true))), Boolean(overallSummary.totals.spendingAccountFloatCharge && overallSummary.totals.spendingAccountFloatCharge !== 0) && /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1
    }
  }, "Spending Account Float"), /*#__PURE__*/_react["default"].createElement(_Text["default"], null, _sbUtils.helpers.formatNumber(overallSummary.totals.spendingAccountFloatCharge, 2, true))), Boolean(overallSummary.totals.asoArrearsFloatCharge && overallSummary.totals.asoArrearsFloatCharge !== 0) && /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.asoFloat)), /*#__PURE__*/_react["default"].createElement(_Text["default"], null, _sbUtils.helpers.formatNumber(overallSummary.totals.asoArrearsFloatCharge, 2, true))), /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.subtotal)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    bold: true
  }, _sbUtils.helpers.formatNumber(carryForward + overallSummary.totals.premium + (overallSummary.totals.adjustments instanceof Object ? overallSummary.totals.adjustments.net : overallSummary.totals.adjustments) + (overallSummary.totals.asoAdjustments || 0) + (overallSummary.totals.spendingAccountFloatCharge || 0) + (overallSummary.totals.asoArrearsFloatCharge || 0), 2, true))), /*#__PURE__*/_react["default"].createElement(_DividerLine.DividerLine, null), /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.pst)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    bold: true
  }, _sbUtils.helpers.formatNumber(overallSummary.totals.PST + (overallSummary.totals.RST || 0), 2, true))), /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.gstHst)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    bold: true
  }, _sbUtils.helpers.formatNumber((overallSummary.totals.HST || 0) + (overallSummary.totals.GST || 0), 2, true))), overallSummary.totals.CCFee ? /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.convenienceFee)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    bold: true
  }, _sbUtils.helpers.formatNumber(overallSummary.totals.CCFee, 2, true))) : null, /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    large: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.totalDue)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    large: true,
    bold: true
  }, _sbUtils.helpers.formatNumber(overallSummary.totals.grandTotal, 2, true))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    margin: "30px 0"
  }, _i18n["default"].t(_tokens["default"].labels.invoices.carryForwardAmountDue)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    margin: "0 0 20px 0"
  }, _i18n["default"].t(_tokens["default"].labels.invoices.processingYourPayment)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true
  }, _i18n["default"].t(_tokens["default"].labels.invoices.summaryBreakdown)));
};
var _default = exports["default"] = Summary;